import React, { useEffect, useState } from "react";
import { Upload } from "@progress/kendo-react-upload";
import { Error } from "@progress/kendo-react-labels";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import ErrorHelper from "../../helper/error-helper";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import APP_ROUTES from "../../helper/app-routes";
import { useNavigate } from "react-router";

const FileUpload = () => {  
    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validateError, setValidateError] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [uploadError, setUploadError] = useState(false);
  const [errors, setErrors] = useState("");
  const [region, setRegion] = useState([]);
  const [fields, setFields] = useState({
    regionId: "",
  });

  const [inputFields, setInputFields] = useState([
    {
      code: "",
      description: "",
    },
  ]);

  useEffect(() => {
    getRegion();
  }, []);

  const getRegion = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.GET_REGIONS)
      .then((result) => {
        setLoading(false);
        let data = result.resultData;
        setRegion(data);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!fields.docName || fields.docName.trim().length === 0) {
      formIsValid = false;
      errors["docName"] = ErrorHelper.DOCUMENT_NAME;
    }
    if (attachments.length === 0) {
      formIsValid = false;
      errors["upload"] = ErrorHelper.UPLOAD_DOCUMENT;
      setUploadError(true);
    }
    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    setValidateError(true);
    // if (handleValidation()) {
    saveDocument();
    // }
  };

  const onAdd = (event) => {
    setAttachments(event.newState);
    setUploadError(false);
  };

  const onRemove = (event) => {
    setAttachments(event.newState);
  };

  const onStatusChange = (event) => {
    setAttachments(event.newState);
  };
  const saveDocument = () => {
    setLoading(true);
    let data = {
      regionId: fields.regionId.id,
      icdZipfile:
        attachments.length > 0
          ? attachments.map((file) => file.getRawFile())
          : null,
      icdJsonString: JSON.stringify(inputFields),
    };
    ApiHelper.multipartPostRequest(ApiUrls.UPLOAD_FILE, data)
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Upload file successfully");
        // navigate(AppRoutes.STORED_DOCUMENTS);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };

  const addFields = () => {
    let newfield = { code: "", description: "" };
    setInputFields([...inputFields, newfield]);
  };
    const onCancel = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <>
      <div className="d-flex flex-wrap">
        {/* {loading === true && <Loader />} */}
        <div className="col-md-9 col-lg-10">
          <div className="Service-RateList">
            <div className="d-flex justify-content-between  mt-3">
              <h4 className="address-title text-grey ">
                <span className="f-24">Dx code</span>
              </h4>
            </div>
          </div>
          <div className="col mt-3 ">
            <div className="mb-3 col-lg-5 col-md-6 col-12 px-0  custom-drop">
              <Upload
                batch={false}
                multiple={true}
                autoUpload={false}
                files={attachments}
                defaultFiles={attachments}
                onAdd={onAdd}
                onRemove={onRemove}
                onStatusChange={onStatusChange}
                withCredentials={false}
                showActionButtons={false}
                ariaDescribedBy={"firstNameError"}
              />
              {uploadError && <Error>Document is required</Error>}
            </div>
            <div className="mb-3 col-lg-5 col-md-6 col-12 px-0 edit-Service-popup">
              <DropDownKendoRct
                validityStyles={validateError}
                label="Region"
                onChange={handleChange}
                data={region}
                value={fields.regionId}
                textField="regionName"
                name="regionId"
                error={fields.regionId === "" && errors.regionId}
                required={true}
              />
            </div>
            <div className="row">
              <button
                className="mb-3 col-lg-2 col-md-6 col-12 green-btn btn-primary "
                style={{ display: "none" }}
                onClick={addFields}
              >
                New Add
              </button>
              {/* <div className="row"> */}
              {inputFields.map((input, index) => {
                return (
                  <>
                    <div key={index} className="col-md-7">
                      <div className="input-document-cus">
                        <input
                          onChange={(event) => handleFormChange(index, event)}
                          value={input.code}
                          size="40"
                          placeholder="code"
                          name="code"
                          className="mb-3"
                        />
                        <input
                          onChange={(event) => handleFormChange(index, event)}
                          value={input.description}
                          size="40"
                          placeholder="description"
                          name="description"
                          className=""
                        />
                      </div>
                    </div>
                    <div className="col-md-5"></div>
                  </>
                );
              })}
              {/* </div> */}
            </div>

            <div className="footer-composer mt-2 col-lg-5 col-md-6 col-12 px-0">
              <span className="position-relative">
                <div className="d-flex mt-4">
                  <div className="right-sde">
                    <button className="green-btn btn-primary" onClick={handleSubmit}>
                      Upload
                    </button>
                  </div>
                  <div className="right-sde-grey mx-3">
                    <button className="btn grey-secondary text-white "
                    onClick={onCancel}>
                      Cancel
                    </button>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FileUpload;
